
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniahireforpunedarshan() {



    const cardData =
    {
        keyword: 'Urbania Hire for Pune Darshan',
        heading: 'Amruta Travels: Urbania Hire for Pune Darshan',
        headingDescription: 'Amruta Travels offers Urbania Hire for Pune Darshan, providing a comfortable and convenient travel solution for sightseeing and exploring Pune’s famous temples, historical sites, and cultural attractions. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities to ensure a smooth and enjoyable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes your Pune Darshan trip safe, hassle-free, and full of comfort and style.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Urbania bus hire for Pune Darshan",
      "description": "Urbania bus hire for Pune Darshan offering comfortable, AC-equipped buses for group sightseeing and city tours."
    },
    {
      "name": "Urbania bus on rent for Pune Darshan",
      "description": "Urbania bus on rent for Pune Darshan for family trips, group tours, and city sightseeing with professional drivers."
    },
    {
      "name": "Force Urbania bus Pune Darshan",
      "description": "Force Urbania bus for Pune Darshan providing luxury seating, spacious interiors, and AC comfort for premium sightseeing tours."
    },
    {
      "name": "Urbania bus rental Pune sightseeing",
      "description": "Urbania bus rental in Pune for sightseeing trips covering major attractions with comfortable, safe, and air-conditioned buses."
    },
    {
      "name": "Urbania bus hire Pune city tour",
      "description": "Urbania bus hire for Pune city tour, ideal for local sightseeing, corporate tours, and family excursions with reliable service."
    },
    {
      "name": "13 seater Urbania bus for Pune Darshan",
      "description": "13 seater Urbania bus for Pune Darshan, perfect for small groups or families seeking a comfortable city tour experience."
    },
    {
      "name": "17 seater Urbania bus for Pune Darshan",
      "description": "17 seater Urbania bus for Pune Darshan, ideal for larger groups and corporate sightseeing trips with AC comfort."
    },
    {
      "name": "Luxury Urbania bus hire Pune Darshan",
      "description": "Luxury Urbania bus hire for Pune Darshan with premium interiors, spacious seating, and professional drivers for VIP sightseeing tours."
    },
    {
      "name": "AC Urbania bus Pune sightseeing",
      "description": "AC Urbania bus for Pune sightseeing ensuring cool and comfortable travel across all popular attractions."
    },
    {
      "name": "Force Urbania 17 seater bus Pune Darshan",
      "description": "Force Urbania 17 seater bus for Pune Darshan designed for group tours, corporate outings, and long day city tours with AC comfort."
    },
    {
      "name": "Urbania bus hire in Pune for city tour",
      "description": "Urbania bus hire in Pune for city tours, suitable for families, corporate groups, and organized sightseeing trips."
    },
    {
      "name": "Urbania bus Pune local sightseeing",
      "description": "Urbania bus for Pune local sightseeing covering popular attractions like Shaniwar Wada, Dagdusheth Ganpati, and other landmarks."
    },
    {
      "name": "Urbania bus Pune one day tour",
      "description": "Urbania bus for Pune one day tour, perfect for quick city trips, local darshan, or weekend sightseeing with reliable service."
    },
    {
      "name": "Urbania bus hire Pune local darshan",
      "description": "Urbania bus hire for Pune local darshan covering key temples, historical sites, and city attractions with comfortable travel."
    },
    {
      "name": "Urbania bus rental Pune city trip",
      "description": "Urbania bus rental for Pune city trips, suitable for schools, corporate outings, and family excursions with AC and professional drivers."
    },
    {
      "name": "Urbania bus hire for Pune sightseeing places",
      "description": "Urbania bus hire covering popular Pune sightseeing places like Aga Khan Palace, Pataleshwar Cave Temple, and local markets."
    },
    {
      "name": "Urbania bus for Shaniwar Wada Pune Darshan",
      "description": "Urbania bus for Shaniwar Wada Pune Darshan with comfortable seating and AC interiors for groups visiting the iconic landmark."
    }
  ],
  "tableData": [
    ["Urbania bus hire for Pune Darshan", "Urbania bus on rent for Pune Darshan"],
    ["Force Urbania bus Pune Darshan", "Urbania bus rental Pune sightseeing"],
    ["Urbania bus hire Pune city tour", "13 seater Urbania bus for Pune Darshan"],
    ["17 seater Urbania bus for Pune Darshan", "Luxury Urbania bus hire Pune Darshan"],
    ["AC Urbania bus Pune sightseeing", "Force Urbania 17 seater bus Pune Darshan"],
    ["Urbania bus hire in Pune for city tour", "Urbania bus Pune local sightseeing"],
    ["Urbania bus Pune one day tour", "Urbania bus hire Pune local darshan"],
    ["Urbania bus rental Pune city trip", "Urbania bus hire for Pune sightseeing places"],
    ["Urbania bus for Shaniwar Wada Pune Darshan", "Urbania bus hire for Pune Darshan"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Perfect Urbania Hire for Pune Darshan",
    "WhyChoosedescription": "Amruta Travels offers Urbania Hire for Pune Darshan, providing a comfortable, stylish, and convenient way to explore the city’s top attractions with family, friends, or groups."
  },
  {
    "WhyChooseheading": "Ideal for Group and Family Travel",
    "WhyChoosedescription": "Whether you are planning a family outing, sightseeing tour, or group trip, our Urbania ensures spacious seating, comfort, and a premium travel experience while exploring Pune."
  },
  {
    "WhyChooseheading": "Comfortable and Luxurious Interiors",
    "WhyChoosedescription": "Urbania vehicles feature plush seating, generous legroom, air conditioning, large windows, and ample luggage space, making them ideal for a full day of sightseeing around Pune."
  },
  {
    "WhyChooseheading": "Professional and Friendly Drivers",
    "WhyChoosedescription": "All Urbania hires come with experienced and courteous drivers who are familiar with Pune’s routes and attractions, ensuring a smooth, safe, and enjoyable travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for Urbania hires for Pune Darshan, giving you excellent value for money without any hidden charges."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain the highest standards of hygiene, comfort, and safety during your Pune Darshan tour."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations and customized routes for Pune Darshan, allowing you to explore all major attractions according to your schedule."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania for Pune Darshan is quick and hassle-free with Amruta Travels. Our friendly support team assists you at every step for a seamless and enjoyable experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania for Pune Darshan?',
    answer: 'You can book an Urbania for Pune Darshan by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you throughout the booking process.'
  },
  {
    question: 'Is Urbania suitable for Pune sightseeing tours?',
    answer: 'Yes, Urbania is ideal for Pune Darshan, offering spacious seating, comfort, and air conditioning for a pleasant sightseeing experience.'
  },
  {
    question: 'Can I customize the Pune Darshan route?',
    answer: 'Absolutely! We offer customized routes for Pune Darshan based on your preferences, ensuring you visit all the major attractions comfortably.'
  },
  {
    question: 'Does the Urbania hire include a driver?',
    answer: 'Yes, every Urbania hire includes a professional and experienced driver familiar with Pune’s routes for a smooth and safe journey.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Yes, all our Urbania vehicles are regularly serviced, cleaned, and sanitized to provide comfort, safety, and hygiene during your Pune Darshan tour.'
  },
  {
    question: 'What is the cost of hiring Urbania for Pune Darshan?',
    answer: 'The rental cost depends on the duration, distance, and type of sightseeing planned. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I get multiple pickup and drop-off points for Pune Darshan?',
    answer: 'Yes, we provide flexible pickup and drop-off options, allowing you to plan your Pune Darshan tour conveniently.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania hire for Pune Darshan?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and dedicated support to ensure a comfortable and hassle-free Pune Darshan experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ashok Patil',
    role: 'Family Traveler, Pune',
    text: 'We hired an Urbania for Pune Darshan. The vehicle was spacious and comfortable, and the driver was knowledgeable and professional. Made our sightseeing trip smooth and enjoyable!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Priya Kulkarni',
    role: 'Group Traveler, Pune',
    text: 'Booked an Urbania for a Pune sightseeing tour. Excellent comfort, smooth ride, and the driver helped us cover all major attractions without any hassle. Highly recommend Amruta Travels!',
    rating: 5
  }
];



























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus Hire for Pune Darshan",
  "image": "https://bushireinpune.com/assets/images/urbania-pune-darshan.jpg",
  "description": "Rent 13 & 17 seater Force Urbania buses for Pune Darshan tours with Amruta Travels. Ideal for family trips, corporate outings, school trips, and senior citizen tours. Cover popular Pune sightseeing spots like Shaniwar Wada, Dagdusheth Ganpati, Sinhagad, Parvati Hill, and more with AC and luxury options.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1780"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-pune-darshan"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania Bus Hire for Pune Darshan | Force Urbania | Amruta Travels</title>
  <meta
    name="description"
    content="Book Urbania bus for Pune Darshan with Amruta Travels. 13 & 17 seater Force Urbania buses for family, corporate, school trips & sightseeing of Shaniwar Wada, Dagdusheth Ganpati, Sinhagad, and Parvati Hill."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/120.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniahireforpunedarshan;